const store = {
    namespaced: true,
    state() {
        return {
            news: [],
            article: {},
            recArticles: [],
            page: 1,
            totalPagesCount: 1,
            totalCount: 0,
            isNewsLoading: false,
            statuses: [],
            newsByStatus: [],
            randomProducts: []
        };
    },
    getters: {
        getNewsLargeFirst(state) {
            return state.news.slice(0, 2);
        },
        getNewsSmallFirst(state) {
            return state.news.slice(2, 6);
        },
        getChunks(state) {
            return state.news.length / 6;
        },
        getAllNews(state) {
            return state.news;
        },
        getArticle(state) {
            return state.article;
        },
        getRecArticlesLarge(state) {
            return state.recArticles.length === 2 ? state.recArticles.slice(0, 1) : state.recArticles.slice(0, 2);
        },
        getRecArticlesSmall(state) {
            return state.recArticles.length === 2 ? state.recArticles.slice(1, 2) : state.recArticles.slice(2, 6);
        },
        getPage(state) {
            return state.page;
        },
        getTotalPagesCount(state) {
            return state.totalPagesCount;
        },
        getTotalCount(state) {
            return state.totalCount;
        },
        getIsNewsLoading(state) {
            return state.isNewsLoading;
        },
        getStatuses(state) {
            return state.statuses;
        },
        getNewsByStatus(state) {
            return state.newsByStatus;
        },
        getRandomProducts(state) {
            return state.randomProducts;
        }
    },
    mutations: {
        setNews(state, news) {
            state.news = news;
        },
        setArticle(state, article) {
            state.article = article;
        },
        setRecArticles(state, articles) {
            state.recArticles = articles;
        },
        addNews(state, news) {
            //state.news.concat(news)
            news.map(e => {
                state.news.push(e);
            });
        },
        setPage(state, page) {
            state.page = page;
        },
        setTotalPagesCount(state, pages) {
            state.totalPagesCount = pages;
        },
        setTotalCount(state, totalCount) {
            state.totalCount = totalCount;
        },
        SET_IS_NEWS_LOADING(state, value) {
            state.isNewsLoading = value;
        },
        SET_STATUSES(state, statuses) {
            state.statuses = statuses;
        },
        SET_NEWS_BY_STATUS(state, news) {
            state.newsByStatus = news;
        },
        SET_RANDOM_PRODUCTS(state, products) {
            state.randomProducts = products;
        }
    },
    actions: {
        async changePage({ commit }, { query, page }) {
            if (!page) {
                page = 1;
            }

            commit('setPage', page);

            if (process.server) {
                return;
            }

            if (page !== 1) {
                await this.$router.push({ query: { ...query, page: page } });
                return;
            }

            const newQuery = { ...query };

            if (newQuery.tab === 0) {
                delete newQuery.tab;
            }

            delete newQuery.page;

            await this.$router.push({ query: newQuery });
        },
        async fetchNews({ commit, rootGetters }, { statusId = 0, page = 1 } = {}) {
            const isFarmacie = rootGetters['global/getIsFarmacie'];
            commit('SET_IS_NEWS_LOADING', true);

            let url = 'base/articles/';

            if (statusId && page) {
                url += `?status_id=${statusId}&page=${page}`;
            } else {
                url += `?page=${page}`;
            }

            try {
                const news = await this.$axios.$get(url);

                if (isFarmacie) {
                    const randomProducts = await this.$axios.$get('/general/product-filter/promo/');
                    commit('SET_RANDOM_PRODUCTS', randomProducts);
                }

                if (news.data) {
                    if (statusId === 0) {
                        commit('setNews', news.data);
                    } else {
                        commit('SET_NEWS_BY_STATUS', news.data);
                    }
                    commit('setTotalCount', news.totalCount);
                    commit('setTotalPagesCount', news.pages);
                    commit('SET_STATUSES', news.statuses);
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('SET_IS_NEWS_LOADING', false);
            }
        }
    }
};

export default store;
